import React from 'react';

import './animation.scss';



const Animation = ({ tag, header, type }) => {
  const animationName = type ? type :
      tag === 'web' || tag ==='interior' ? 'cubes'
      : tag === 'branding' || tag === 'pr/video' ? 'blobs'
      : tag === 'prom' || tag ==='interface' ? 'glass'
      : tag === 'pr' || tag ==='navigation' ? 'tube'
      : tag === 'smm' || tag ==='urban' || tag === 'inclusive' ? 'figures'
      : 'rings';

  const ticker = React.useRef();

  React.useEffect(() => {
    const el = ticker.current;

    if (!el) {
      return;
    }

    const width = el.clientWidth;
    const coef = (width / 1000).toFixed(1);
    el.style.animationDuration = `${coef * 6}s`;
  }, []);



  return (
      <React.Fragment>
        <div className="animation sheen-container">
          <div className="sheen-scene sheen-w100 sheen-h125 sheen-media-h100"
               data-scene={
                 animationName === 'tube' ? `/competencies/models/${animationName}.glb` : `/competencies/models/${animationName}-meshopt.glb`
               }
               data-fallback={
                 animationName !== 'tube' ? `/competencies/models/${animationName}.glb` : null
               }
               data-lights="/competencies/hdri/studio_small_04_256.hdr"
               data-lightsrot={
                 animationName === 'glass' ? '[0,0,0]' : null
               }
          />
          <div
              className="sheen-preview sheen-loading-screen sheen-w100 sheen-h125 sheen-media-h100"
              style={{ backgroundImage: `url(/competencies/images/${animationName}-thumbnail.jpg)` }}
          />
          {
            header &&
            <div className="ticker">
              <h2 ref={ticker} className="ticker__text">
                {header}
              </h2>
            </div>

          }
          <div className="sheen-progressBar"/>
        </div>
      </React.Fragment>
  );
}

export default Animation;
